import React from "react";
import Modal from "react-bootstrap/Modal";
import { BsCalendarWeekFill } from "react-icons/bs";
import AssignShift from "../components/AssignShift";

const AssignShiftModal = ({ visible, close, shift, updateShift, pending }) => {
  return (
    <Modal
      show={visible}
      onHide={close}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={"text-capitalize"}
        >
          <h1 className={"text-axis-offblack icon-text-wrapper"}>
            <BsCalendarWeekFill />{" "}
            {shift?.user?.surname === null || shift?.user?.surname === undefined
              ? pending === true
                ? "Save Pending"
                : "Assign"
              : "Approve"}
            {" Shift"}
          </h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <AssignShift
            shift={shift}
            makePending={pending}
            onComplete={(s) => {
              updateShift(s);
              close();
            }}
            close={close}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AssignShiftModal;
